/* Craftybella PDP v2 — core behaviour
   Shared helpers, gallery, quantity, variants, sticky bar, FBT.
   Feature modules (cb-pdp-form.js, cb-pdp-photos.js) attach through CB.mods. */
window.CB = window.CB || {};
(function (CB) {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function inr(paise) {
    var n = Math.round(paise) / 100;
    var s = (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    var parts = s.split('.');
    var x = parts[0];
    var last3 = x.slice(-3);
    var rest = x.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    return '₹' + last3 + (parts[1] ? '.' + parts[1] : '');
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cb-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Gallery ---------- */
  function gallery(root) {
    var track = $('[data-cb-track]', root);
    if (!track) return;
    var slides = $$('[data-cb-slide]', track);
    var thumbs = $$('[data-cb-thumb]', root);
    var count = $('[data-cb-count]', root);
    if (!slides.length) return;

    function idx() {
      var w = track.clientWidth || 1;
      return Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    }
    function sync() {
      var i = idx();
      if (count) count.textContent = (i + 1) + '/' + slides.length;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      slides.forEach(function (s, n) {
        var v = s.querySelector('video');
        if (v && n !== i && !v.paused) v.pause();
      });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    var prev = $('[data-cb-prev]', root), next = $('[data-cb-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });

    window.addEventListener('resize', function () { sync(); });
    sync();
  }

  /* ---------- Character counters ---------- */
  function counters(root) {
    $$('[data-cb-counted]', root).forEach(function (inp) {
      var out = $('[data-cb-count-for="' + inp.id + '"]', root);
      if (!out) return;
      var max = parseInt(inp.getAttribute('maxlength'), 10) || 0;
      function upd() {
        out.textContent = inp.value.length + '/' + max;
        out.classList.toggle('cb-count--warn', max > 0 && inp.value.length >= max);
      }
      inp.addEventListener('input', upd);
      upd();
    });
  }

  /* ---------- Quantity ---------- */
  function qty(root) {
    $$('[data-cb-qty]', root).forEach(function (box) {
      var input = $('input', box);
      $$('button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-cb-step') === 'up' ? 1 : -1;
          var v = (parseInt(input.value, 10) || 1) + step;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          input.value = Math.max(min, v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Accordions ---------- */
  function accordions(root) {
    $$('[data-cb-acc]', root).forEach(function (item) {
      var btn = $('[data-cb-acc-btn]', item);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Simple toggles ---------- */
  function toggles(root) {
    $$('[data-cb-toggle]', root).forEach(function (btn) {
      var target = $('#' + btn.getAttribute('data-cb-toggle'), root);
      if (!target) return;
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Wishlist (visual) ---------- */
  function wish(root) {
    $$('[data-cb-wish]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') === 'true';
        b.setAttribute('aria-pressed', on ? 'false' : 'true');
        toast(on ? 'Removed from your saved list' : 'Saved to your list');
      });
    });
  }

  /* ---------- Pincode estimator ---------- */
  function pincode(root) {
    var box = $('[data-cb-pin]', root);
    if (!box) return;
    var cfgEl = $('[data-cb-pin-config]', root);
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var input = $('input', box);
    var btn = $('[data-cb-pin-go]', box);
    var out = $('[data-cb-pin-out]', box);

    function listHas(list, pin) {
      return (list || []).some(function (p) { return pin.indexOf(String(p).trim()) === 0; });
    }

    function check() {
      var pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = pin;
      out.classList.add('is-open');
      if (pin.length !== 6) {
        out.innerHTML = '<div class="cb-pin__err">Please enter a valid 6-digit pincode.</div>';
        return;
      }
      if (listHas(cfg.blocked, pin)) {
        out.innerHTML = '<div class="cb-pin__err">' + (cfg.blocked_text || 'We are unable to deliver to this pincode right now.') + '</div>';
        return;
      }
      var min = cfg.days_min, max = cfg.days_max, cod = cfg.cod_default;
      if (listHas(cfg.fast, pin)) { min = cfg.fast_min; max = cfg.fast_max; }
      else if (listHas(cfg.slow, pin)) { min = cfg.slow_min; max = cfg.slow_max; cod = cfg.cod_slow; }

      var range = (min === max) ? (min + ' days') : (min + '–' + max + ' days');
      var html = '<div class="cb-pin__ok">' + (cfg.ok_prefix || 'Usually delivers in') + ' ' + range + '</div>';
      var meta = [];
      if (cod) meta.push('Cash on delivery available');
      else meta.push('Prepaid only for this pincode');
      if (cfg.note) meta.push(cfg.note);
      html += '<div class="cb-pin__meta">' + meta.join(' · ') + '</div>';
      out.innerHTML = html;
    }

    if (btn) btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  }

  /* ---------- Cart ---------- */
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.dispatchEvent(new CustomEvent('cb:cart:updated', { detail: c }));
        var sels = ['[data-cart-count]', '.t4s-cart-count', '.cart-count-bubble span', '#CartCount', '.t4s-sticky-count'];
        sels.forEach(function (s) {
          $$(s).forEach(function (el) {
            if (el && /^\s*\d*\s*$/.test(el.textContent)) el.textContent = c.item_count;
          });
        });
        return c;
      })
      .catch(function () {});
  }

  /* ---------- Shared with the feature modules ---------- */
  CB.$ = $;
  CB.$$ = $$;
  CB.inr = inr;
  CB.toast = toast;
  CB.addToCart = addToCart;
  CB.refreshCartCount = refreshCartCount;
  CB.mods = CB.mods || [];

  /* ---------- Variant picker ---------- */
  function variants(root) {
    var sel = $('[data-cb-variant]', root);
    if (!sel) return;
    var priceEl = $('[data-cb-price]', root);
    var cmpEl = $('[data-cb-compare]', root);
    var offEl = $('[data-cb-off]', root);

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
      var cmp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      if (priceEl) priceEl.textContent = inr(price);
      if (cmpEl) {
        cmpEl.textContent = cmp > price ? inr(cmp) : '';
        cmpEl.style.display = cmp > price ? '' : 'none';
      }
      if (offEl) {
        if (cmp > price) {
          offEl.textContent = Math.round(((cmp - price) / cmp) * 100) + '% OFF';
          offEl.style.display = '';
        } else { offEl.style.display = 'none'; }
      }
      var sn = $('.cb-sticky__now');
      if (sn) sn.textContent = inr(price);
      /* Snapmint reads this element's text to work out the EMI amount. */
      var snap = $('[data-cb-snap-price]', root);
      if (snap) snap.textContent = inr(price);
    });
  }

  /* ---------- Sticky bar visibility ----------
     This used to be an IntersectionObserver with a single threshold, which
     gave the bar exactly one trigger line: scroll a few pixels back and forth
     across it and the bar flickered in and out, which is what made it feel
     unsteady. There are two lines now, 56px apart -- it appears once the real
     Add to cart button is well above the fold, and only goes away again once
     that button is nearly back in view. In between, whatever state it is in is
     left alone. That gap is what makes slow scrolling calm.

     The reading is taken once per animation frame rather than once per scroll
     event, so a fast flick costs the same as a slow drag. */
  function stickyBar(root) {
    var bar = $('[data-cb-sticky]');
    var anchor = $('[data-cb-add]', root);
    if (!bar || !anchor) return;

    var SHOW_AT = -56;   /* button's bottom edge this far above the fold */
    var HIDE_AT = 0;     /* ...and back to the fold before it goes away */
    var on = false, queued = false;

    function frame() {
      queued = false;
      var b = anchor.getBoundingClientRect().bottom;
      /* A hidden or detached button measures 0 and would otherwise read as
         "scrolled past" on every frame. */
      if (!anchor.offsetParent && anchor.offsetHeight === 0) return;
      if (!on && b < SHOW_AT) { on = true; bar.classList.add('is-on'); }
      else if (on && b > HIDE_AT) { on = false; bar.classList.remove('is-on'); }
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(frame);
    }

    frame();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    /* The gallery and the variant picker change the page height under the
       button, so re-check when the layout settles rather than trusting the
       position it had at load. */
    [250, 900, 2000].forEach(function (d) { setTimeout(schedule, d); });
  }

  /* ---------- Frequently bought together ---------- */
  function fbt(root) {
    var box = $('[data-cb-fbt]', root);
    if (!box) return;
    var boxes = $$('[data-cb-fbt-cb]', box);
    var totEl = $('[data-cb-fbt-total]', box);
    var wasEl = $('[data-cb-fbt-was]', box);
    var svEl = $('[data-cb-fbt-save]', box);
    var btn = $('[data-cb-fbt-add]', box);

    function calc() {
      var now = 0, was = 0, n = 0;
      boxes.forEach(function (cb) {
        if (!cb.checked) return;
        n++;
        now += parseInt(cb.getAttribute('data-price'), 10) || 0;
        was += parseInt(cb.getAttribute('data-compare'), 10) || parseInt(cb.getAttribute('data-price'), 10) || 0;
      });
      if (totEl) totEl.textContent = inr(now);
      if (wasEl) { wasEl.textContent = was > now ? inr(was) : ''; }
      if (svEl) {
        if (was > now) {
          var pct = Math.round(((was - now) / was) * 100);
          svEl.textContent = 'You save ' + inr(was - now) + ' (' + pct + '%)';
          svEl.style.display = '';
        } else { svEl.style.display = 'none'; }
      }
      if (btn) btn.disabled = n === 0;
    }

    boxes.forEach(function (cb) { cb.addEventListener('change', calc); });
    calc();

    if (btn) btn.addEventListener('click', function () {
      var items = boxes.filter(function (cb) { return cb.checked; }).map(function (cb) {
        /* the main product carries the shopper's personalised note — reuse it */
        if (cb.getAttribute('data-cb-fbt-main') && typeof window.__cbMainPayload === 'function') {
          var p = window.__cbMainPayload();
          return { id: p.id, quantity: p.quantity, properties: p.properties };
        }
        return { id: cb.getAttribute('data-variant'), quantity: 1 };
      });
      if (!items.length) return;
      var label = btn.innerHTML;
      btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(items)
        .then(function () { return refreshCartCount(); })
        .then(function () { btn.disabled = false; btn.innerHTML = label; toast(items.length + ' items added to your cart'); })
        .catch(function (e) { btn.disabled = false; btn.innerHTML = label; toast(e.message || 'Could not add these items'); });
    });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    var s = scope || document;
    $$('[data-cb-pdp]', s).forEach(function (root) {
      if (root.__cbInit) return;
      root.__cbInit = true;
      gallery(root); counters(root); qty(root); accordions(root); toggles(root);
      wish(root); pincode(root); variants(root); stickyBar(root); fbt(root);
      (CB.mods || []).forEach(function (f) { try { f(root); } catch (err) {} });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  /* Theme editor re-render */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})(window.CB);
